import {Injectable} from "@angular/core";
import { DefaultService} from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ControllerCardTypeService {

  constructor(private powerSupplyService: DefaultService) { }

  // getAllControllerCardTypes() {
  //   return this.powerSupplyService.getControllerCardTypes().pipe(map(result => result));
  // }

  // createControllerCardTypes(cardType: ControllerCardType) {
  //   return this.powerSupplyService.createControllerCardType(cardType).pipe(map(result => result));
  // }

  // updateControllerCardTypes(cardType: ControllerCardType) {
  //   return this.powerSupplyService.updateControllerCardType(cardType).pipe(map(result => result));
  // }

  // deleteControllerCardTypes(id: number) {
  //   return this.powerSupplyService.deleteControllerCardType(id).pipe(map(result => result));
  // }
}
